import { configureStore } from '@reduxjs/toolkit';
import {rootReducer} from '../reducer/reducers';

export default configureStore({
    reducer: rootReducer,
});